import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={12}
    fill="currentColor"
    viewBox="0 0 16 12"
    {...props}
  >
    <path
      fill="#999"
      d="M11.75 12a.73.73 0 0 1-.534-.215.72.72 0 0 1-.216-.534V7.506q0-.318.216-.537a.72.72 0 0 1 .534-.219h3.5q.319 0 .534.215A.72.72 0 0 1 16 7.5v3.745a.74.74 0 0 1-.216.537.72.72 0 0 1-.534.219zm-4.5-6.75a.73.73 0 0 1-.534-.215A.72.72 0 0 1 6.5 4.5V.756q0-.318.216-.537A.72.72 0 0 1 7.25 0h8q.319 0 .534.215A.72.72 0 0 1 16 .75v3.745a.74.74 0 0 1-.216.537.72.72 0 0 1-.534.219zM.75 12a.73.73 0 0 1-.534-.215A.72.72 0 0 1 0 11.25V7.506q0-.318.216-.537A.72.72 0 0 1 .75 6.75h8q.319 0 .534.215A.72.72 0 0 1 9.5 7.5v3.745a.74.74 0 0 1-.216.537.72.72 0 0 1-.534.219zm0-6.75a.73.73 0 0 1-.534-.215A.72.72 0 0 1 0 4.5V.756Q0 .438.216.219A.72.72 0 0 1 .75 0h3.5q.319 0 .534.215A.72.72 0 0 1 5 .75v3.745a.74.74 0 0 1-.216.537.72.72 0 0 1-.534.219zM8 3.75h6.5V1.5H8zM1.5 10.5H8V8.25H1.5zm11 0h2V8.25h-2zm-11-6.75h2V1.5h-2z"
    />
  </svg>
);
export default SvgStreamlineDashboard;
